// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import '../static/js/reset_rem.js'
import '../static/css/normalize.css'
import '../static/css/animate.min.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import Services from './api/index.js'
Vue.prototype.$api = new Services()

import * as swiperAni from "../static/js/swiper.animate.min.js"
import vueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// swiper.animate.min.js动画
Vue.prototype.$swiperAnimateCache = swiperAni.swiperAnimateCache;
Vue.prototype.$swiperAnimate = swiperAni.swiperAnimate;
Vue.prototype.$clearSwiperAnimate = swiperAni.clearSwiperAnimate;

Vue.use(vueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js